import { EDIT_COMPONENT_TYPE } from '../../../constants/constants'

import SidebarShadowCard from './SidebarShadowCard'

import { Button } from '@/components/ui/base'

interface SidebarProps {
  collapsed: boolean
  onToggle: () => void
  onAdd: (type: string) => void
  title?: string
}

export function Sidebar({
  collapsed,
  onToggle,
  onAdd,
  title = 'Click a component below to add to your pattern:',
}: SidebarProps) {
  return (
    <div
      className="sidebar"
      style={{
        width: collapsed ? 42 : 256,
        background: 'rgb(255, 255, 255)',
        border: '1px solid rgb(229, 231, 235)',
        borderRadius: 12,
        minHeight: 'auto',
        minWidth: collapsed ? 42 : 256,
        transition: 'width 0.24s, min-width 0.24s',
        zIndex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: collapsed ? 'center' : 'flex-start',
        boxShadow: 'none',
        marginTop: 0,
        marginBottom: 0,
        padding: collapsed ? 0 : 16,
        position: 'sticky',
        top: '24px',
        height: 'fit-content',
        alignSelf: 'flex-start',
      }}
    >
      <div
        style={{
          margin: collapsed ? '16px 0' : '0 0 16px 0',
          alignSelf: collapsed ? 'center' : 'flex-start',
        }}
      >
        <Button
          iconName={collapsed ? 'angle-left' : 'angle-right'}
          variant="icon"
          onClick={onToggle}
          ariaLabel="Collapse sidebar"
        />
      </div>
      {!collapsed && (
        <div style={{ padding: 0, width: '100%' }}>
          <div
            style={{
              fontWeight: 600,
              fontSize: 14,
              marginBottom: 4,
              color: 'rgb(17, 24, 39)',
              letterSpacing: 0,
              marginTop: 0,
              lineHeight: 1.4,
            }}
          >
            Add Components
          </div>
          <div
            style={{
              fontSize: 12,
              color: 'rgb(107, 114, 128)',
              marginBottom: 16,
              fontWeight: 400,
            }}
          >
            {title}
          </div>
          <SidebarShadowCard
            variant={EDIT_COMPONENT_TYPE.IMAGE_LEFT_TEXT_RIGHT}
            label="Image Left / Text Right"
            onClick={() => onAdd(EDIT_COMPONENT_TYPE.IMAGE_LEFT_TEXT_RIGHT)}
          />
          <SidebarShadowCard
            variant={EDIT_COMPONENT_TYPE.TEXT_LEFT_IMAGE_RIGHT}
            label="Text Left / Image Right"
            onClick={() => onAdd(EDIT_COMPONENT_TYPE.TEXT_LEFT_IMAGE_RIGHT)}
          />
          <SidebarShadowCard
            variant={EDIT_COMPONENT_TYPE.MULTI_IMAGE}
            imageCount={1}
            label="Single Image"
            onClick={() => onAdd(EDIT_COMPONENT_TYPE.MULTI_IMAGE + ':1')}
          />
          <SidebarShadowCard
            variant={EDIT_COMPONENT_TYPE.MULTI_IMAGE}
            imageCount={2}
            label="Two Images"
            onClick={() => onAdd(EDIT_COMPONENT_TYPE.MULTI_IMAGE + ':2')}
          />
          <SidebarShadowCard
            variant={EDIT_COMPONENT_TYPE.MULTI_IMAGE}
            imageCount={3}
            label="Three Images"
            onClick={() => onAdd(EDIT_COMPONENT_TYPE.MULTI_IMAGE + ':3')}
          />
          <SidebarShadowCard
            variant={EDIT_COMPONENT_TYPE.TIP}
            label="Alert Box"
            onClick={() => onAdd(EDIT_COMPONENT_TYPE.TIP)}
          />
          <SidebarShadowCard
            variant={EDIT_COMPONENT_TYPE.TEXT_ONLY}
            label="Text Block"
            onClick={() => onAdd(EDIT_COMPONENT_TYPE.TEXT_ONLY)}
          />
        </div>
      )}
    </div>
  )
}

export default Sidebar
